// sagas/innerCircleSaga.js

import { put, call, takeLatest } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import {
  adminInnerCircleLoad,
  adminInnerCircleSuccess,
  adminInnerCircleFail,
  adminCreateActivityLoad,
  adminCreateActivitySuccess,
  adminCreateActivityFail,
  adminCreateInnerCircleLoad,
  adminCreateInnerCircleSuccess,
  adminCreateInnerCircleFail,
  adminGetCircleListLoad,
  adminGetCircleListSuccess,
  adminGetCircleListFail,
  adminInnerCircleDetailLoad,
  adminInnerCircleDetailSuccess,
  adminInnerCircleDetailFail,
  adminAddUserinCircleLoad,
  adminAddUserinCircleSuccess,
  adminAddUserinCircleFail,
  adminAddUserCircleLoad,
  adminAddUserCircleSuccess,
  adminAddUserCircleFail,
  adminInnerCircleGlobalListLoad,
  adminInnerCircleGlobalListSuccess,
  adminInnerCircleGlobalListFail
} from "../slices/adminInner.slice";

import {
  addUserApi,
  addUserInCircleApi,
  adminGetCirclePostListAPI,
  createInnerCircleApi,
  innerCircleApi,
  AdminInnerCircleDetailApi,
  getCommentListApi,
  innerCircleGloabListApi
} from "../Api/api";

function* innerCircleSaga(action) {
  try {
    const data = yield call(innerCircleApi, action.payload);
    if (data.status === 0) {
      yield put(adminInnerCircleSuccess(data.result.data));
    } else {
      yield put(adminInnerCircleFail());
    }
  } catch (e) {
    console.error("Inner circle saga error:", e);
    yield put(adminInnerCircleFail());
  }
}

function* addUserSaga(action) {
  try {
    let data = yield call(addUserApi, action.payload);
    if (data.status === 0) {
      yield put(adminAddUserCircleSuccess(data.result.data));
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      yield put(adminAddUserCircleFail());
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch (error) {
    yield put(adminAddUserCircleFail());
    toast.error("Failed to add user", { position: "top-right", autoClose: 3000 });
  }
}

function* createInnerCircleSaga(action) {
  try {
    let data = yield call(createInnerCircleApi, action.payload);
    if (data.status === 0) {
      yield put(adminCreateInnerCircleSuccess(data.result.data));
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      yield put(adminCreateInnerCircleFail());
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch {
    yield put(adminCreateInnerCircleFail());
    toast.error("Failed to create inner circle", { position: "top-right", autoClose: 3000 });
  }
}

function* innerCircleDetailSaga(action) {
  try {
    let data = yield call(AdminInnerCircleDetailApi, action.payload);
    if (data.status === 0) {
      yield put(adminInnerCircleDetailSuccess(data.result.data));
    } else {
      yield put(adminInnerCircleDetailFail());
    }
  } catch {
    yield put(adminInnerCircleDetailFail());
  }
}

function* addUserCircleSaga(action) {
  try {
    let data = yield call(addUserInCircleApi, action.payload);
    if (data.status === 0) {
      yield put(adminAddUserinCircleSuccess(data.result.data));
      toast.success(data.result.message, { position: "top-right", autoClose: 3000 });
    } else {
      yield put(adminAddUserinCircleFail());
      toast.error(data.result.message, { position: "top-right", autoClose: 3000 });
    }
  } catch {
    yield put(adminAddUserinCircleFail());
    toast.error("Failed to add user to circle", { position: "top-right", autoClose: 3000 });
  }
}

function* getCirclePostListSaga(action) {
  try {
    let data = yield call(adminGetCirclePostListAPI, action.payload);
    if (data.status === 0) {
      yield put(adminGetCircleListSuccess(data.result.data));
    } else {
      yield put(adminGetCircleListFail());
    }
  } catch {
    yield put(adminGetCircleListFail());
  }
}



function* innerCircleGlobalListSaga(action) {
  try {
    let data = yield call(innerCircleGloabListApi, action.payload);
    if (data.status === 0) {
      yield put(adminInnerCircleGlobalListSuccess(data.result.data));
    } else {
      yield put(adminInnerCircleGlobalListFail());
    }
  } catch {
    yield put(adminInnerCircleGlobalListFail());
  }
}

export default function* rootAdminInnerCircleSaga() {
  yield takeLatest(adminInnerCircleLoad.type, innerCircleSaga);
  yield takeLatest(adminAddUserCircleLoad.type, addUserSaga);
  yield takeLatest(adminCreateInnerCircleLoad.type, createInnerCircleSaga);
  yield takeLatest(adminInnerCircleDetailLoad.type, innerCircleDetailSaga);
  yield takeLatest(adminAddUserinCircleLoad.type, addUserCircleSaga);
  yield takeLatest(adminGetCircleListLoad.type, getCirclePostListSaga);
  yield takeLatest(adminInnerCircleGlobalListLoad.type, innerCircleGlobalListSaga);
}
